import styled, { css } from 'styled-components';
import { List as ListComponent } from './List';

export const List = styled(ListComponent)(
  () => css`
    padding: 0;
  `,
);
